/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {LineItemRetailProductModalComponent} from './line-item-retail-product-modal.component';

@Injectable({providedIn: 'root'})
export class LineItemRetailProductModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(lineItemId: string, onComplete: () => void): void {
    this.angularModalService.show(LineItemRetailProductModalComponent, {
      class: 'modal-lg',
      initialState: {
        lineItemId,
        onComplete
      }
    });
  }
}
